// extracted by mini-css-extract-plugin
export var typingIndicator = "_pa-0";